import { BaseUploadNodeProps } from "imagica-uikit/dist/nodesV2/typing";
import styles from "./Html.module.scss";

function Html(props: BaseUploadNodeProps) {
  const { createBlobUrl, uuid } = props;
  return <iframe title={uuid} className={styles.HtmlContainer} src={createBlobUrl?.objectURL}></iframe>;
}

export { Html };
